import {
  Agent,
  Channel,
  Configuration,
  getCurrencyByPurchaseCountry,
  getLocaleByPurchaseCountry,
  getStructure,
  MerchantStructure,
  PurchaseCountry,
  setEnvironment,
} from '@nemuru-eng/js-api-client';
import { useAuth } from '@nemuru-eng/providers';

import { getLanguageByLocale } from '@/components/shared/components/LanguageSelector/constants/LanguageParams';
import { useLanguages } from '@/components/shared/components/LanguageSelector/hooks/useLanguages';
import { ENV_ENV } from '@/config/envVars';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { UserEntity } from '@/entities/UserEntity';
import UserInMerchantStructure from '@/entities/UserInMerchantStructure';

export const useInitApplication = () => {
  const { updateUserContext } = useUserContext();
  const { user, logout } = useAuth();
  const { setLanguageByUrlParam } = useLanguages();

  const initApplication = async () => {
    if (!user) return;

    let userEntity: UserEntity | UserInMerchantStructure = new UserEntity(user);

    if (userEntity.isRoleSupported() === false) {
      updateUserContext({
        authError: true,
      });
      logout();
      return;
    }

    let currentAgent = undefined as unknown as Agent | undefined;
    let currentChannel = undefined as unknown as Channel | undefined;
    let structure = undefined as unknown as MerchantStructure | undefined;

    if (userEntity.requiresStructure()) {
      structure = await getStructure();
      userEntity = new UserInMerchantStructure(user, structure);
      if (userEntity instanceof UserInMerchantStructure) {
        currentAgent = userEntity.agent;
        currentChannel = userEntity.channel;
      }
    }

    const purchaseCountry = currentAgent?.allowedPurchaseCountries[0] ?? PurchaseCountry.ESP;
    const locale = getLocaleByPurchaseCountry(purchaseCountry);
    const currency = getCurrencyByPurchaseCountry(purchaseCountry);
    const supportedLanguage = getLanguageByLocale(locale);

    // Reset environment to set locale based on purchase country
    setEnvironment(
      ENV_ENV,
      new Configuration({
        currency,
        locale,
      }),
    );

    // Set language in app
    setLanguageByUrlParam(supportedLanguage);

    updateUserContext({
      agent: currentAgent,
      structure,
      currentAgent,
      currentChannel,
      userEntity,
      appStarted: true,
    });
  };

  return { initApplication };
};
